import { _saveNewGroupMember, _removeMemberFromGroup, _toggleAdmin, _updateMemberDisplayName } from "../../data/groupMembers";
import { _toggleInactiveUser } from "../../data/groups";
import { toggleModal } from "../../utils/uiUtils";

const AddMember = ({ addMember, buttonClass, groupId }) => {

    const addNewMember = async () => {
        const newMemberName = document.getElementById("newMemberName").value;
        await addMember(groupId, newMemberName);
        document.getElementById("newMemberName").value = "";
        toggleModal("modal-addMember");
    }

    return (
        <>
            <button className={"button " + buttonClass} onClick={() => { toggleModal("modal-addMember") }}>Add Member</button>
            <div id="modal-addMember" className="modal">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-text-centered">
                        <p className="modal-card-title">Add Member</p>
                        <button className="delete" aria-label="close" onClick={() => { toggleModal('modal-addMember') }}></button>
                    </header>
                    <section className="modal-card-body">
                        <div className="field is-horizontal">
                            <div className="field-label is-normal">
                                <label className="label">Name</label>
                            </div>
                            <div className="field-body">
                                <div className="field">
                                    <p className="control is-expanded">
                                        <input className="input" type="text" id="newMemberName" placeholder="Member Name" />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="is-size-6">
                            Enter the display name for the member. When you send the ivite link to members and they join they can link their name to their account.

                        </div>
                    </section>
                    <footer className="modal-card-foot has-text-right">
                        <button className="button is-primary" onClick={() => { addNewMember(); }}>Add Member</button>
                        <button className="button" aria-label="close" onClick={() => { toggleModal('modal-addMember') }}>Close</button>
                    </footer>
                </div>
            </div>
        </>
    )
};

export default AddMember;